import { render } from "./GB_results.vue?vue&type=template&id=9eacc5d2"
import script from "./GB_results.vue?vue&type=script&lang=js"
export * from "./GB_results.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__